import { TypedSupabaseClient } from "../../utils/types";
import dayjs from "dayjs";

export function getParkings(client: TypedSupabaseClient, limit: number = 100) {
  return client
    .from("parkings")
    .select(
      `id, make(name), model, color, ticket, venue_id, created_by:users(id, full_name), status, created_at, venue:venues(name, id), parking_events(timestamp, type, user_id), paid, payment_method`
    )
    .order("created_at", { ascending: false })
    .limit(limit);
}
